import {
  ConfigurationDetailsContext,
  ConfiguratorSummaryContext,
  ModularConfiguratorSummaryContext,
} from '../app/shared/regions/RegionDataContext';
import { RegionManager } from '../app/shared/regions/RegionManager';
import { AppState } from './AppState';
import ConfigurationDetailsActions from './configurationDetails/ConfigurationDetailsActions';
import { ConfigurationDetailsActionsState } from './configurationDetails/ConfigurationDetailsActionsState';
import { ConfiguratorActions } from './configurator/ConfiguratorActions';
import { ConfiguratorActionsState } from './configurator/ConfiguratorActionsState';
import { ModularConfiguratorActions } from './modularConfigurator/ModularConfiguratorActions';
import { ModularConfiguratorActionsState } from './modularConfigurator/ModularConfiguratorActionsState';

export default function (regionManager: RegionManager) {
  regionManager.registerViewWithRegion(
    'ConfiguratorSummary',
    (data: ConfiguratorSummaryContext['data'], appState: AppState) => {
      return new ConfiguratorActionsState(
        data.configurator,
        data.store,
        appState.client,
        appState.navigation,
        appState.eventAggregator,
        appState.translation.configuratorActions,
      );
    },
    ConfiguratorActions,
  );
  regionManager.registerViewWithRegion(
    'ConfigurationDetails',
    (data: ConfigurationDetailsContext['data'], appState: AppState) => {
      return new ConfigurationDetailsActionsState(
        data.details,
        data.code,
        appState.store,
        appState.client,
        appState.navigation,
        appState.eventAggregator,
        appState.translation.configuratorActions,
        appState.translation.configurationPage,
        appState.translation.configurationDetailsPage,
      );
    },
    ConfigurationDetailsActions,
  );
  regionManager.registerViewWithRegion(
    'ModularConfiguratorSummary',
    (data: ModularConfiguratorSummaryContext['data'], appState: AppState) => {
      return new ModularConfiguratorActionsState(
        data.state,
        appState.store,
        appState.client,
        appState.navigation,
        appState.eventAggregator,
        appState.translation.configuratorActions,
      );
    },
    ModularConfiguratorActions,
  );
}
